import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Currency from '../entities/currency';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';

interface CurrencyState extends ListState<Currency> {
  currency: Currency;
  editCurrency: Currency;
}

class CurrencyMutations extends ListMutations<Currency> {}

class CurrencyModule extends ListModule<CurrencyState, any, Currency> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Currency>(),
    loading: false,
    editCurrency: new Currency(),
    selectCurrency: new Currency(),
  };
  actions = {
    async selectCurrency(
      context: ActionContext<CurrencyState, any>,
      payload: any
    ) {
      context.state.editCurrency = payload.data;
    },

    async saveCurrency(
      context: ActionContext<CurrencyState, any>,
      payload: any
    ) {
      let reponse = await Ajax.post(
        '/api/services/app/Content/SaveCurrency',
        payload.data
      );

      let page = reponse.data.result as PageResult<Currency>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async updateCurrency(
      context: ActionContext<CurrencyState, any>,
      payload: any
    ) {
      let reponse = await Ajax.put(
        '/api/services/app/Content/UpdateCurrency',
        payload.data
      );

      let page = reponse.data.result as PageResult<Currency>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getCurrencies(
      context: ActionContext<CurrencyState, any>,
      payload: any
    ) {
      // context.state.loading=true;
      let reponse = await Ajax.get(
        '/api/services/app/Content/GetCurrencies',
        payload.data
      );

      // context.state.loading=false;
      let page = reponse.data.result as PageResult<Currency>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async deleteCurrency(
      context: ActionContext<CurrencyState, any>,
      payload: any
    ) {
      await Ajax.delete(
        '/api/services/app/Flight/DeleteCurrency?input=' + payload.payload
      );
    },
  };
  mutations = {
    setCurrentPage(state: CurrencyState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: CurrencyState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const currencyModule = new CurrencyModule();
export default currencyModule;
